import { trackStructEvent } from "@snowplow/browser-tracker";
import { ONEPASS_ACTION_REWARD, ONEPASS_CATEGORY } from "@analytics/consts";
export function emitRewardImpression() {
  trackStructEvent({
    category: ONEPASS_CATEGORY,
    action: ONEPASS_ACTION_REWARD,
    label: "Impression"
  });
}